import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useDispatch } from "react-redux";
import { processRavenPayment } from "../../../../../store/modules/payments";
import {
  ArrowCircle,
  CardPaymentIcon,
  RavenIcon,
} from "../../../../../assets/svgIcons";

export const PaymentViaCardPrompt = ({
  amount = "",
  closeModal = () => {},
  chargeOutsideApp = () => {},
}) => {
  const dispatch = useDispatch();

  return (
    <>
      <div>
        <div
          className={`${globalStyles.cardWithBorder} cursor-pointer flex-row align-items-center mb-3`}
          style={{ gap: "15px" }}
          onClick={() => {
            dispatch(
              processRavenPayment({
                amount: amount,
                allowFeedBack: false,
              }),
            );
          }}
        >
          <div
            className="d-flex justify-content-center"
            style={{ gap: "10px" }}
          >
            <RavenIcon />
            <div>
              <h6 className="mb-0">Use Raven</h6>
              <p className="small-text-size">
                Process the payment through Raven. It is connected to your
                checkout and automatically reconciles payments with your sales.
              </p>
            </div>
          </div>
          <ArrowCircle stroke="#15112D" width="20" height="20" />
        </div>

        <div
          className={`${globalStyles.cardWithBorder} cursor-pointer flex-row align-items-center`}
          style={{ gap: "15px" }}
          onClick={() => {
            chargeOutsideApp();
            closeModal();
          }}
        >
          <div
            className="d-flex justify-content-center"
            style={{ gap: "10px" }}
          >
            <CardPaymentIcon width="40" height="41" />
            <div>
              <h6 className="mb-0">Card payment already collected</h6>
              <p className="small-text-size">
                If you have already collected the payment before reaching this
                point choose this option.
              </p>
            </div>
          </div>
          <ArrowCircle stroke="#15112D" width="20" height="20" />
        </div>
      </div>
    </>
  );
};
